// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Print: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 63 49"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path d="M58.5 14.8h-2.8v-4.2c0-1.5-1.2-2.8-2.8-2.8h-.8c-.8 0-1.4.6-1.4 1.4s.6 1.4 1.4 1.4h.8v4.2h-4.2V2.3c0-.8-.6-1.4-1.4-1.4H15.6c-.8 0-1.4.6-1.4 1.4v12.5H10v-4.2h.8c.8 0 1.4-.6 1.4-1.4s-.6-1.4-1.4-1.4H10c-1.5 0-2.8 1.2-2.8 2.8v4.2H4.5c-1.5 0-2.8 1.2-2.8 2.8V37c0 1.5 1.2 2.8 2.8 2.8h6.3c.8 0 1.4-.6 1.4-1.4s-.6-1.4-1.4-1.4H4.5v-4.2h54.1V37h-6.3c-.8 0-1.4.6-1.4 1.4s.6 1.4 1.4 1.4h6.3c1.5 0 2.8-1.2 2.8-2.8V17.5c-.1-1.5-1.4-2.7-2.9-2.7zM16.9 3.7H46v11.1H16.9V3.7zM4.5 30V17.5h54.1V30H4.5z"/><path d="M47.4 34.8c-.8 0-1.4.6-1.4 1.4v7.7H16.9v-7.7c0-.8-.6-1.4-1.4-1.4s-1.4.6-1.4 1.4v9.1c0 .8.6 1.4 1.4 1.4h31.9c.8 0 1.4-.6 1.4-1.4v-9.1c0-.8-.6-1.4-1.4-1.4z"/></svg>;
};

export default React.memo(Print);
